






import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'StudioCommunityGroupDescription',
  computed: {
    ...mapGetters({
      group: 'community/currentGroup',
    }),
    description() {
      return this.group?.about_text;
    },
  },
});
